import { render } from "./Cookies.vue?vue&type=template&id=0e23020d&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"

import "../assets/styles/gdpr.css?vue&type=style&index=0&id=0e23020d&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e23020d"]])

export default __exports__